import React, { useContext, useState, useEffect } from "react";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import { AppContext } from "../../store/AppContext";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CategoryIcon from "@mui/icons-material/Category";
import InventoryIcon from "@mui/icons-material/Inventory";
import GroupIcon from "@mui/icons-material/Group";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DiscountOutlinedIcon from "@mui/icons-material/DiscountOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

function SideBar() {
  const {
    setSelectedTab,
    selectedTab,
    setHeaderData,
    isCollapsed,
    setIsCollapsed,
    handleResetTabInfo,
    isMobileSidebarOpen,
    setIsMobileSidebarOpen,
  } = useContext(AppContext);

  const [isMobile, setIsMobile] = useState(false);

  // Check screen size and update mobile state
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // Auto-collapse on tablet sizes
      if (window.innerWidth < 1024 && window.innerWidth >= 768) {
        setIsCollapsed(true);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, [setIsCollapsed]);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobile &&
        isMobileSidebarOpen &&
        !event.target.closest(".sidebar-container")
      ) {
        setIsMobileSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile, isMobileSidebarOpen, setIsMobileSidebarOpen]);

  const sideBarData = [
    {
      title: "Dashboard",
      icon: (
        <HomeIcon
          sx={{
            color: "white",
            width: "26px",
            height: "26px",
            cursor: "pointer",
          }}
        />
      ),
    },
    {
      title: "Orders",
      icon: (
        <ContentPasteIcon
          sx={{
            color: "white",
            width: "26px",
            height: "24px",
            cursor: "pointer",
          }}
        />
      ),
      subCategories: [
        {
          title: "All orders",
          icon: (
            <ListAltIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    },
    {
      title: "Products",
      icon: (
        <AppsOutlinedIcon
          sx={{
            color: "white",
            width: "26px",
            height: "26px",
            cursor: "pointer",
          }}
        />
      ),
      subCategories: [
        {
          title: "All products",
          icon: (
            <InventoryIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "Categories",
          icon: (
            <CategoryIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    },
    {
      title: "Customers",
      icon: (
        <PeopleAltOutlinedIcon
          sx={{
            color: "white",
            width: "26px",
            height: "26px",
            cursor: "pointer",
          }}
        />
      ),
    },
    {
      title: "Coupons",
      icon: (
        <DiscountOutlinedIcon
          sx={{
            color: "white",
            width: "26px",
            height: "26px",
            cursor: "pointer",
          }}
        />
      ),
    },
    {
      title: "Customer Engagement",
      icon: (
        <CampaignOutlinedIcon
          sx={{
            color: "white",
            width: "26px",
            height: "26px",
            cursor: "pointer",
          }}
        />
      ),
      subCategories: [
        {
          title: "Overview",
          icon: (
            <ViewSidebarOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "WhatsApp Campaigns",
          icon: (
            <ForumOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "Abandoned Cart",
          icon: (
            <ShoppingCartOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "Templates",
          icon: (
            <ArticleOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "Audience",
          icon: (
            <ManageSearchOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "Message Logs",
          icon: (
            <MessageOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
        {
          title: "Settings",
          icon: (
            <SettingsOutlinedIcon
              sx={{
                color: "white",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    },
  ];

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      console.log("User signed out successfully");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const handleMenuItemClick = (data, index) => {
    handleResetTabInfo();
    setSelectedTab(
      data?.subCategories
        ? selectedTab?.subCategory?.index !== 0 && !selectedTab?.subCategory
          ? {
              subCategory: { index: 0 },
              category: { title: data.title, index: index },
            }
          : {
              ...selectedTab,
              category: { title: data.title, index: index },
            }
        : {
            category: { title: data.title, index: index },
          }
    );
    setHeaderData({
      leftText: "",
      rightActionText: "",
      leftAction: () => {},
      rightAction: () => {},
    });

    // Close mobile menu after selection
    if (isMobile) {
      setIsMobileSidebarOpen(false);
    }
  };

  const handleSubMenuItemClick = (data, index, data2, index2) => {
    setSelectedTab({
      category: { title: data.title, index: index },
      subCategory: {
        title: data2.title,
        index: index2,
      },
    });
    setHeaderData({
      leftText: "",
      rightActionText: "",
      leftAction: () => {},
      rightAction: () => {},
    });

    // Close mobile menu after selection
    if (isMobile) {
      setIsMobileSidebarOpen(false);
    }
  };

  // Backdrop for mobile
  const MobileBackdrop = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 19,
        display: isMobile && isMobileSidebarOpen ? "block" : "none",
      }}
      onClick={() => setIsMobileSidebarOpen(false)}
    />
  );

  // Calculate sidebar width and positioning
  const getSidebarStyles = () => {
    if (isMobile) {
      return {
        height: "100vh",
        width: "280px",
        position: "fixed",
        left: isMobileSidebarOpen ? "0" : "-280px",
        top: "0",
        zIndex: 20,
        transition: "left 0.3s ease",
      };
    } else {
      return {
        height: "100vh",
        width: isCollapsed ? "80px" : "250px",
        position: "fixed",
        left: "0",
        top: "0",
        zIndex: 20,
        transition: "width 0.4s ease",
        minWidth: isCollapsed ? "80px" : "200px",
      };
    }
  };

  return (
    <>
      <MobileBackdrop />

      <div
        className="sidebar-container"
        style={{
          ...getSidebarStyles(),
          background: "linear-gradient(to bottom, #002E99, #001A66)",
          padding: isMobile ? "20px 16px" : "16px",
          borderRadius: "0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowY: "auto",
          overflowX: "hidden",
          boxShadow: isMobile
            ? "2px 0 8px rgba(0,0,0,0.3)"
            : "2px 0 4px rgba(0,0,0,0.1)",
        }}
      >
        <div>
          {/* Header Section */}
          <div
            style={{
              width: "100%",
              display: "flex",
              padding: "8px 0",
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              marginBottom: "20px",
            }}
          >
            {(!isCollapsed || isMobile) && (
              <h3
                style={{
                  fontWeight: "600",
                  color: "white",
                  margin: "0",
                  fontSize: isMobile ? "1.3rem" : "1.2rem",
                  textAlign: "center",
                }}
              >
                Kathy's
              </h3>
            )}
          </div>

          {/* Navigation Menu */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "4px",
              alignItems: "flex-start",
            }}
          >
            {sideBarData.map((data, index) => {
              const isActive = index === selectedTab?.category?.index;

              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div
                    className={`sidebar-item ${isActive ? "active" : ""}`}
                    style={{
                      display: "flex",
                      padding: isMobile ? "14px 16px" : "12px 16px",
                      cursor: "pointer",
                      justifyContent:
                        isCollapsed && !isMobile ? "center" : "flex-start",
                      borderRadius: "10px",
                      alignItems: "center",
                      gap: "14px",
                      backgroundColor: isActive
                        ? "rgba(255, 255, 255, 0.15)"
                        : "transparent",
                      transition: "all 0.2s ease",
                      minHeight: "48px",
                      margin: "2px 0",
                    }}
                    onClick={() => handleMenuItemClick(data, index)}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor =
                          "rgba(255, 255, 255, 0.08)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    {data.icon}
                    {(!isCollapsed || isMobile) && (
                      <h3
                        style={{
                          fontWeight: isActive ? "500" : "400",
                          color: "white",
                          margin: "0",
                          cursor: "pointer",
                          fontSize: isMobile ? "1rem" : "0.95rem",
                        }}
                      >
                        {data.title}
                      </h3>
                    )}
                  </div>

                  {/* Submenu */}
                  <div style={{ marginTop: "4px" }}>
                    {data.subCategories &&
                      index === selectedTab?.category?.index &&
                      data.subCategories.map((data2, index2) => {
                        const isSubActive =
                          index2 === selectedTab?.subCategory?.index &&
                          index === selectedTab?.category?.index;

                        return (
                          <div
                            onClick={() =>
                              handleSubMenuItemClick(data, index, data2, index2)
                            }
                            key={index2}
                            style={{
                              display: "flex",
                              gap: "14px",
                              padding: isMobile ? "10px 16px" : "8px 16px",
                              cursor: "pointer",
                              opacity: isSubActive ? "1" : "0.8",
                              borderRadius: "8px",
                              justifyContent:
                                isCollapsed && !isMobile
                                  ? "center"
                                  : "flex-start",
                              alignItems: "center",
                              backgroundColor: isSubActive
                                ? "rgba(255, 255, 255, 0.1)"
                                : "transparent",
                              transition: "all 0.2s ease",
                              minHeight: "42px",
                              marginLeft:
                                isCollapsed && !isMobile ? "0" : "20px",
                              marginBottom: "2px",
                            }}
                            onMouseEnter={(e) => {
                              if (!isSubActive) {
                                e.currentTarget.style.backgroundColor =
                                  "rgba(255, 255, 255, 0.05)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isSubActive) {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                              }
                            }}
                          >
                            {(!isCollapsed || isMobile) && (
                              <div
                                style={{ width: "14px", height: "14px" }}
                              ></div>
                            )}
                            {data2.icon}
                            {(!isCollapsed || isMobile) && (
                              <h4
                                style={{
                                  margin: "0",
                                  fontWeight: isSubActive ? "500" : "400",
                                  color: "white",
                                  cursor: "pointer",
                                  fontSize: isMobile ? "0.9rem" : "0.85rem",
                                }}
                              >
                                {data2.title}
                              </h4>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom section with sign out and version */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            paddingBottom: isMobile ? "30px" : "20px",
            marginTop: "20px",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            paddingTop: "20px",
          }}
        >
          {/* Sign Out Button */}
          <div
            onClick={handleSignOut}
            style={{
              display: "flex",
              padding: isMobile ? "14px 16px" : "12px 16px",
              cursor: "pointer",
              justifyContent:
                isCollapsed && !isMobile ? "center" : "flex-start",
              borderRadius: "10px",
              alignItems: "center",
              gap: "14px",
              transition: "background-color 0.2s ease",
              minHeight: "48px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                "rgba(255, 255, 255, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            <LogoutIcon
              sx={{
                color: "white",
                width: "26px",
                height: "26px",
                cursor: "pointer",
              }}
            />
            {(!isCollapsed || isMobile) && (
              <h3
                style={{
                  fontWeight: "400",
                  color: "white",
                  margin: "0",
                  cursor: "pointer",
                  fontSize: isMobile ? "1rem" : "0.95rem",
                }}
              >
                Sign Out
              </h3>
            )}
          </div>

          {/* Version Number */}
          {(!isCollapsed || isMobile) && (
            <div
              style={{
                color: "rgba(255, 255, 255, 0.5)",
                fontSize: isMobile ? "0.8rem" : "0.75rem",
                textAlign: "center",
                padding: "0 10px",
              }}
            >
              Version 1.0.0
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SideBar;
